export default {
      id: "warehouse-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#warehouse",
      toString: function () {
        return this.url;
      }
    }